<img
  alt=""
  width="100%"
  height="100%"
  (load)="setShowLoader()"
  [src]="data.imageUrl ? data.imageUrl : 'data:image/jpeg;base64,' + data.image"
/>

<mat-spinner
  *ngIf="showLoader"
  mode="indeterminate"
  diameter="20"
></mat-spinner>
